import React, { useState } from 'react';

import { LoadingWheel } from '../base/LoadingWheel';
import { FormSelect } from '../base/Form/FormSelect';
import clsx from 'clsx';
import useApplianceModels from '../../data/appliance/useApplianceModel';

export interface FormModelSelectProps {
  manufacturer: string;
  type: string;
  label?: string;
}

export const FormModelSelect = React.forwardRef<any, FormModelSelectProps>(
  ({ manufacturer, type, label, ...rest }, ref) => {
    const { applianceModels } = useApplianceModels(
      manufacturer === '0' ? undefined : manufacturer,
      type === '0' ? undefined : type
    );
    const [open, setOpen] = useState(false);

    if (applianceModels.isLoading) {
      return (
        <div className="h-full flex items-center justify-center">
          <LoadingWheel size="sm" />
        </div>
      );
    } else {
      return (
        <div
          className="relative"
          onMouseEnter={
            !manufacturer && manufacturer !== '0'
              ? () => setOpen(true)
              : () => {}
          }
          onMouseLeave={
            !manufacturer && manufacturer !== '0'
              ? () => setOpen(false)
              : () => {}
          }
        >
          <FormSelect
            disabled={!type || !manufacturer || manufacturer === '0'}
            ref={ref}
            label={label ? label : 'Model'}
            {...rest}
          >
            <option disabled selected value="0">
              Please Select
            </option>
            {applianceModels.data?.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </FormSelect>
          <div
            className={clsx(
              open ? 'block ' : 'hidden ',
              'absolute z-20 left-6 mt-2 top-16 px-3 py-2 rounded-md border border-red-500 bg-red-300/90 dark:border-red-700 dark:bg-red-600/90'
            )}
          >
            You must choose a Manufacturer first
          </div>
        </div>
      );
    }
  }
);
